<template>
  <div class="app-container msg-new-edit">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
      <el-row>
        <el-col :span="2">
          <div>内容</div>
        </el-col>
        <el-col :span="12">
          <el-input type="textarea" v-model.trim="content" :maxlength="5000" rows="5" ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div>链接</div>
        </el-col>
        <el-col :span="12">
          <el-input type="textarea" v-model.trim="link" :maxlength="255" rows="2" ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div>接收者</div>
        </el-col>
        <el-col :span="12">
          <el-select
            v-model="noticeTo">
            <el-option
              :label="'所有人'"
              :value="-1">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <input class="send-input" type="checkbox" v-model="isSendWxCpNews">
        <label class="send-label">发送企业微信通知</label>
      </el-row>
    </basic-container>
  </div>
</template>

<script>
import { saveMsg } from '@/api/msg/notice';

export default {
  data () {
    return {
      content: '',
      link: '',
      noticeTo: -1,
      userOptions: [],
      isSendWxCpNews: false,
    }
  },
  methods: {
    cancel() {
      this.$router.$avueRouter.closeTag();
      this.$router.back();
    },
    async submit() {
      if (!this.content) {
        this.$message({
          showClose: true,
          message: '请输入消息内容',
          type: 'error',
        });
        return;
      }

      if (this.noticeTo !== -1) {
        this.$message({
          showClose: true,
          message: '请选择接收者',
          type: 'error',
        });
        return;
      }

      const params = {
        noticeTo: this.noticeTo,
        noticeToType: 2, // 1：个人，2：所有
        noticeContent: this.content,
        link: this.link,
        isSendWxCpNews: this.isSendWxCpNews,
      }

      const response = await this.requestWrapper(saveMsg, params);
      if (!response || response.ok === false) {
        this.$message({
          showClose: true,
          message: '添加消息失败',
          type: 'error',
        });
        return;
      }

      this.$router.back();
    },
  }
}
</script>


<style lang="scss" scoped>
.msg-new-edit {
  .operation {
    text-align: right
  }
  .send-input {
    cursor: pointer;
  }
  .send-label {
    margin-left: 5px;
  }
}
</style>
